import React, { useState } from 'react';
import { dispatchAPI } from '../../../utils/api';
import { FaBarcode, FaCheckCircle } from 'react-icons/fa';
import './GateScanPage.css';

export default function GateScanPage() {
  const [noteId, setNoteId] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [overrideReason, setOverrideReason] = useState('');

  const handleScan = async (e) => {
    e.preventDefault();
    if (!noteId) return;

    try {
      setLoading(true);
      setError(null);
      setResult(null);
      let id = noteId;
      let qr = null;
      try {
        const parsed = new URL(noteId);
        id = parsed.searchParams.get('id') || noteId;
        qr = parsed.searchParams.get('qr');
      } catch {
        // Manual ID entry.
      }
      if (!qr && !overrideReason.trim()) {
        setError('Manual entry requires an override reason.');
        return;
      }
      const res = await dispatchAPI.gateScan(id, qr, qr ? null : overrideReason);
      setResult(res.data);
      setNoteId('');
      setOverrideReason('');
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.message || 'Failed to scan dispatch note.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="inventory-page inventory-gate-page">
      <div className="premium-card inventory-page-card eduss-gate-scan-container">
      <div className="inventory-gate-panel">
        <div className="eduss-icon-circle" style={{ fontSize: '48px', color: '#3498db', marginBottom: '20px' }}>
          <FaBarcode />
        </div>
        <h2>Gate Inward Scan</h2>
        <p>Enter or scan the Dispatch Note ID to record arrival at warehouse.</p>

        <form onSubmit={handleScan} style={{ marginTop: '30px' }}>
          <div className="eduss-form-group">
            <input 
              type="text" 
              className="eduss-input" 
              placeholder="DN-XXXX-XXXX"
              value={noteId}
              onChange={(e) => setNoteId(e.target.value)}
              style={{ fontSize: '20px', textAlign: 'center', padding: '15px' }}
              autoFocus
            />
          </div>
          <div className="eduss-form-group" style={{ marginTop: '12px' }}>
            <input
              type="text"
              className="eduss-input"
              placeholder="Manual override reason"
              value={overrideReason}
              onChange={(e) => setOverrideReason(e.target.value)}
            />
          </div>
          <button 
            type="submit" 
            className="eduss-btn primary large" 
            style={{ width: '100%', marginTop: '20px' }}
            disabled={loading || !noteId}
          >
            {loading ? 'Processing...' : 'Record Arrival'}
          </button>
        </form>

        {error && (
          <div className="eduss-alert error" style={{ marginTop: '20px' }}>
            {error}
          </div>
        )}

        {result && (
          <div className="eduss-alert success" style={{ marginTop: '20px', textAlign: 'left' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FaCheckCircle style={{ color: '#27ae60' }} />
              <strong>Arrival Recorded Successfully!</strong>
            </div>
            <div style={{ marginTop: '10px', fontSize: '14px' }}>
              <p>Reference: {result.reference_no || result.referenceNo}</p>
              <p>Truck: {result.truck_number || result.truckNumber}</p>
              <p>Arrived: {result.gate_arrived_at ? new Date(result.gate_arrived_at).toLocaleString() : '-'}</p>
              <p>Received By: {result.gate_received_by || '-'}</p>
              <p>Status: <span className="eduss-badge blue">{result.status}</span></p>
            </div>
          </div>
        )}
      </div>
      </div>

      <div className="premium-card inventory-page-card inventory-recent-card">
        <h3>Recent Arrivals</h3>
        <p style={{ color: '#7f8c8d' }}>Last 5 vehicles processed at this gate.</p>
        {/* Placeholder for recent arrivals list */}
      </div>

    </div>
  );
}
